import PropTypes from 'prop-types';
import React, { useCallback, useContext, useMemo } from 'react';
import { GridContextProvider } from '@bingads-webui-grid/grid-context';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getRoutePathById } from '@bingads-webui-react/with-site-map';
import { setClarityTag } from '@bingads-webui-universal/clarity';
import { Stack } from '@fluentui/react/lib/Stack';
import {
  Card,
  CardFooter,
  makeStyles,
} from '@fluentui/react-components';
import { getUIBlockerStyle } from './common/styles';
import { LandingPageFooter } from './landing-page/landing-page-footer';
import { LiftStudiesGrid } from './landing-page/lift-studies-grid/grid';
import { Toolbar } from './landing-page/toolbar';


const useStyles = makeStyles({
  footer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  gridMobileView: {
    '@media screen and (max-width: 600px)': {
      width: 'fit-content',
    },
  },
});

export const LiftMeasurement = ({ siteMap }) => {
  useDefaultStyles(getUIBlockerStyle);
  const mainLayoutTokens = {
    childrenGap: 15,
    padding: 30,
  };
  const styles = useStyles();

  const { scope } = useContext(ScopeContext);

  const onClickCreate = useCallback(() => {
    setClarityTag({
      IsClickedCreateLiftExperiment: true,
    });
    const route = getRoutePathById(siteMap, 'lift-measurement-creation');
    scope.save(route);
  }, [scope, siteMap]);
  const onClickEdit = useCallback((liftExperimentId) => {
    setClarityTag({
      IsClickedEditLiftExperiment: true,
    });
    const route = getRoutePathById(siteMap, 'lift-measurement-edit');
    scope.append({ liftExperimentId });
    scope.save(route);
  }, [scope, siteMap]);

  const initialGridContext = useMemo(() => ({
    items: [],
    editableFilter: '',
    pagination: {
      pageNumber: 1,
      pageSize: 10,
    },
    totalCount: 0,
  }), []);

  return (
    <div className="lift-measurement-wrapper">
      <Stack tokens={mainLayoutTokens}>
        <GridContextProvider {...initialGridContext}>
          <Toolbar onClickCreate={onClickCreate} />
          <Card className={styles.gridMobileView}>
            <LiftStudiesGrid onClickEdit={onClickEdit} siteMap={siteMap} />
            <CardFooter className={styles.footer}>
              <LandingPageFooter />
            </CardFooter>
          </Card>
        </GridContextProvider>
      </Stack >
    </div >
  );
};

LiftMeasurement.propTypes = {
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
};
